import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home/home'
import aaa from '@/components/home/index'
import login from '@/components/login/index'
import register from '@/components/register/index'
import Assocwindow from '@/components/Assocwindow/index'
import Associvoice from '@/components/Associvoice/index'
import Assocdynamic from '@/components/Assocdynamic/index'
import Themactive from '@/components/Themactive/index'
import Assocpro from '@/components/Assocwindow/Assocpro/index'
import Assocprodetail from '@/components/Assocwindow/Assocpro/Assocprodetail/index'

import Focus from '@/components/Focus/index'
import Foucslist from '@/components/Focus/Foucslist/index'
import Foucsdetail from '@/components/Focus/Foucslist/Foucsdetail/index'

import Memactive from '@/components/Memactive/index'
import Memactivelist from '@/components/Memactive/Memactivelist/index'
import Memactivedetail from '@/components/Memactive/Memactivelist/Memactivedetail/index'


import Aplymember from '@/components/Assocwindow/Aplymember/index'
import ContactInfo from '@/components/Assocwindow/ContactInfo/index'
import ContactInfo1 from '@/components/Assocwindow/ContactInfo/index1'
import ContactInfodetail from '@/components/Assocwindow/ContactInfo/ContactInfodetail/index'
import Instframe from '@/components/Assocwindow/Instframe/index'
import Mandirect from '@/components/Assocwindow/Mandirect/index'
import Directunit from '@/components/Assocwindow/Directunit/index'
import aa from '@/components/aa/index'
import Admiscrit from '@/components/Assocwindow/Admiscrit/index'
import Assocarticle from '@/components/Assocwindow/Assocarticle/index'
import Culturelec from '@/components/Associvoice/Culturelec/index'
import Iscommuni from '@/components/Associvoice/Iscommuni/index'
import NewsCenter from '@/components/Assocdynamic/NewsCenter/index'
import NewsCenter1 from '@/components/Assocdynamic/NewsCenter/index1'
import NonMember from '@/components/Themactive/NonMember/index'
import NonMember1 from '@/components/Themactive/NonMember1/index'
import NonMember2 from '@/components/Themactive/NonMember2/index'
import NonMember3 from '@/components/Themactive/NonMember3/index'
import NonMemberdetail from '@/components/Themactive/NonMember/NonMemberdetail/index'
import Notifiannou from '@/components/Notifiannou/index'
import Notifiannoulist from '@/components/Notifiannou/Notifiannoulist/index'
import Notifiannoudetail from '@/components/Notifiannou/Notifiannoulist/Notifiannoudetail/index'
import NewsCenterdetail from '@/components/Assocdynamic/NewsCenter/NewsCenterdetail/index'
import Iscommunidetail from '@/components/Associvoice/Iscommuni/Iscommunidetail/index'
import Culturelecdetail from '@/components/Associvoice/Culturelec/Culturelecdetail/index'
import Search from '@/components/Search/index'
import Searchdetail from '@/components/Search/Searchdetail/index'

import Specialdetail from '@/components/Specialdetail/index'

import Policy from '@/components/zhengce/index'
import Policych from '@/components/zhengce/zhengcech/index'
import Policydetail  from '@/components/zhengce/zhengcech/zhengcedetail/index'

import Culture from '@/components/Culture/index'
import Culturech from '@/components/Culture/Culturech/index'
import Culturedetail  from '@/components/Culture/Culturech/Culturedetail/index'

import directorInformation from '@/components/directorInformation/index1'
import directorInformation1 from '@/components/directorInformation/index'


import recommend from '@/components/recommend/index'
import recommend1 from '@/components/recommend/index1'


import medium from '@/components/medium/index'
import medium1 from '@/components/medium/index1'

import academic from '@/components/academic/index'
import academic1 from '@/components/academic/index1'
// import Culturedetail  from '@/components/Culture/Culturech/Culturedetail/index'



import Notice from '@/components/Notice/index'
import Noticech from '@/components/Notice/Noticech/index'
import Noticedetail  from '@/components/Notice/Noticech/Noticedetail/index'

Vue.use(Router)
  //学术报道 暂定 只需要id (reportId)
export default new Router({
  scrollBehavior(to,from,savedPosition) {
    if(savedPosition) {
      return savedPosition
    } else {
      return {x:0,y:0}
    }
},
mode:'hash',
    routes: [
    {
      path: '*',
      name: 'index',
      component: home
    },
    {
      //首页
      path:'/home',
      name:'home',
      component:home
    },
    {
      path:'/aaa',
      name:'aaa',
      component:aaa
    },
    {
      // 登录
      path:'/login',
      name:'login',
      component:login
    },
    {
      // 注册
      path:'/register',
      name:'register',
      component:register
    },
    {
      // 协会之窗
      path:'/Assocwindow',
      name:'Assocwindow',
      component:Assocwindow,
      redirect:'/Assocwindow/aa',
      children:[
        {
          path:'/Assocwindow/aa',
          name:'aa',
          component:aa
        },
        {
          // 协会简介
          path:'/Assocwindow/Assocpro',
          name:'Assocpro',
          component:Assocpro
        },
        {
          // 申请入会
          path:'/Assocwindow/Aplymember',
          name:'Aplymember',
          component:Aplymember
        },
        {
          // 协会领导
          path:'/Assocwindow/ContactInfo',
          name:'ContactInfo',
          component:ContactInfo
        },
        {
          // 协会领导
          path:'/Assocwindow/ContactInfo1',
          name:'ContactInfo1',
          component:ContactInfo1
        },
        {
          // 组织机构
          path:'/Assocwindow/Instframe',
          name:'Instframe',
          component:Instframe
        },
        {
          // 常务理事
          path:'/Assocwindow/Mandirect',
          name:'Mandirect',
          component:Mandirect
        },
        {
          // 理事单位
          path:'/Assocwindow/Directunit',
          name:'Directunit',
          component:Directunit
        },

        {
          // 入会标准
          path:'/Assocwindow/Admiscrit',
          name:'Admiscrit',
          component:Admiscrit
        },
        {
          // 协会章程
          path:'/Assocwindow/Assocarticle',
          name:'Assocarticle',
          component:Assocarticle
        }
      ],
      redirect: "/Assocwindow/Assocpro",
    },
    {
      // 协会简介详情
      path:'/Assocwindow/Assocpro/Assocprodetail',
      name:'Assocprodetail',
      component:Assocprodetail
    },
    {
      // 协会领导详情
      path:'/Assocwindow/ContactInfo/ContactInfodetail',
      name:'ContactInfodetail',
      component:ContactInfodetail
    },
    {
      // 学者成果
      path:'/Associvoice',
      name:'Associvoice',
      component:Associvoice,
      children:[
        {
          // 著作
          path:'/Associvoice/Culturelec',
          name:'Culturelec',
          component:Culturelec
        },
        {
          // 文章
          path:'/Associvoice/Iscommuni',
          name:'Iscommuni',
          component:Iscommuni
        }
      ],
      redirect: "/Associvoice/Culturelec",
    },
    {
      path:'/Associvoice/Iscommuni/Iscommunidetail',
      name:'Iscommunidetail',
      component:Iscommunidetail
    },
    {
      path:'/Associvoice/Culturelec/Culturelecdetail',
      name:'Culturelecdetail',
      component:Culturelecdetail
    },
    {
      // 协会动态
      path:'/Assocdynamic',
      name:'Assocdynamic',
      component:Assocdynamic,
      children:[
        {
          path:'/Assocdynamic/NewsCenter',
          name:'NewsCenter',
          component:NewsCenter
        },
        {
          path:'/Assocdynamic/NewsCenter1',
          name:'NewsCenter1',
          component:NewsCenter1

        }
      ],
      redirect: "/Assocdynamic/NewsCenter",
    },
    {
      path:'/Assocdynamic/NewsCenter/NewsCenterdetail',
      name:'NewsCenterdetail',
      component:NewsCenterdetail
    },
    {
      // 政策法规
      path:'/Policy',
      name:'Policy',
      component:Policy,
      children:[
        {
          path:'/Policy/Policych',
          name:'Policych',
          component:Policych
        }
      ],
      redirect: "/Policy/Policych",
    },
    {
      path:'/Policy/Policycd/Policydetail',
      name:'Policydetail',
      component:Policydetail
    },
    {
      // 新闻文化
      path:'/Culture',
      name:'Culture',
      component:Culture,
      children:[
        {
          path:'/Culture/Culturech',
          name:'Culturech',
          component:Culturech
        }
      ],
      redirect: "/Culture/Culturech",
    },
    {
       // 新闻文化
       path:'/directorInformation',
       name:'directorInformation',
       component:directorInformation,
       redirect: "/directorInformation/directorInformation1",
       children:[
         {
           path:'/directorInformation/directorInformation1',
           name:'directorInformation1',
           component:directorInformation1
         }
       ],
      // 理事信息
    },
    {
       // 新闻文化
       path:'/recommend',
       name:'recommend',
       component:recommend,
       redirect: "/recommend/recommend1",
       children:[
         {
           path:'/recommend/recommend1',
           name:'recommend1',
           component:recommend1
         }
       ],
      // 理事信息
    },
    {
      // 新闻文化
      path:'/medium',
      name:'medium',
      component:medium1,
      redirect: "/medium/medium1",
      children:[
        {
          path:'/medium/medium1',
          name:'medium1',
          component:medium
        }
      ],
     // 理事信息
   },
   {
    // 新闻文化
    path:'/academic',
    name:'academic',
    component:academic1,
    redirect: "/academic/academic1",
    children:[
      {
        path:'/academic/academic1',
        name:'academic1',
        component:academic
      }
    ],
   // 理事信息
 },

    // medium
    // {
    //   // 理事信息
    //   path:'/medium',
    //   name:'medium',
    //   component:medium,

    // },
    {
      path:'/Culture/Culturecd/Culturedetail',
      name:'Culturedetail',
      component:Culturedetail
    },
    {
      // 新闻文化
      path:'/Notice',
      name:'Notice',
      component:Notice,
      children:[
        {
          path:'/Notice/Noticech',
          name:'Noticech',
          component:Noticech
        }
      ],
      redirect: "/Notice/Noticech",
    },
    {
      path:'/Notice/Noticech/Noticedetail',
      name:'Noticedetail',
      component:Noticedetail
    },
    {
      // 焦点
      path:'/Focus',
      name:'Focus',
      component:Focus,
      children:[
        {
          path:'/Focus/Foucslist',
          name:'Foucslist',
          component:Foucslist
        }
      ],
      redirect: "/Focus/Foucslist",
    },
    {
      path:'/Focus/Foucslist/Foucsdetail',
      name:'Foucsdetail',
      component:Foucsdetail
    },
    {
      // 会员活动
      path:'/Memactive',
      name:'Memactive',
      component:Memactive,
      children:[
        {
          path:'/Memactive/Memactivelist',
          name:'Memactivelist',
          component:Memactivelist
        }
      ],
      redirect: "/Memactive/Memactivelist",
    },
    {
      path:'/Memactive/Memactivelist/Memactivedetail',
      name:'Memactivedetail',
      component:Memactivedetail
    },
    {
      // 专题活动
      path:'/Themactive',
      name:'Themactive',
      component:Themactive,
      children:[
        {
          path:'/Themactive/NonMember',
          name:'NonMember',
          component:NonMember
        },
        {
          path:'/Themactive/NonMember1',
          name:'NonMember1',
          component:NonMember1
        },
        {
          path:'/Themactive/NonMember2',
          name:'NonMember2',
          component:NonMember2
        },
        {
          path:'/Themactive/NonMember3',
          name:'NonMember3',
          component:NonMember3
        }
      ],
      redirect: "/Themactive/NonMember",
    },
    {
      path:'/Themactive/NonMember/NonMemberdetail',
      name:'NonMemberdetail',
      component:NonMemberdetail
    },
    {
      // 通知公告
      path:'/Notifiannou',
      name:'Notifiannou',
      component:Notifiannou,
      children:[
        {
          // 通知公告
          path:'/Notifiannou/Notifiannoulist',
          name:'Notifiannoulist',
          component:Notifiannoulist
        },
      ],
      redirect: "/Notifiannou/Notifiannoulist"
    },

    {
      // 通知公告
      path:'/Notifiannou/Notifiannoulist/Notifiannoudetail',
      name:'Notifiannoudetail',
      component:Notifiannoudetail
    },
    {
      // 搜索
      path:'/Search',
      name:'Search',
      component:Search
    },
    {
      // 搜索详情
      path:'/Search/Searchdetail',
      name:'Searchdetail',
      component:Searchdetail,
      meta:{
        keepAlive: false // 不需要缓存
      }
    },
    {
      path:'/Specialdetail',
      name:'Specialdetail',
      component:Specialdetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js